import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {numberFormat} from "../../../../../../utilities/moneyFormat";
import ReactTable from "../../../../../conteiners/ReactTable";
import useColumns from "../../../../../Requests/OrderProcessing/utils/hooks/useColumns";
import {selectAllCOfDiscounts} from "../../../KpFinSlice";
import {MAIN_SERVICE_AND_DISCOUNT_TABLE_COLUMNS} from "../../utils";

const MainServicesAndDiscountsTable = () => {
  const {
    i18n: {language},
  } = useTranslation();

  const mainServicesAndDiscountsTableColumns = useColumns(MAIN_SERVICE_AND_DISCOUNT_TABLE_COLUMNS);

  const allDiscounts = useSelector(selectAllCOfDiscounts);
  const discountsTableInfo = allDiscounts?.info;

  const mainServicesAndDiscountsTableData = [
    ...(discountsTableInfo?.map(
      (
        {
          name,
          sumBeforeDiscount,
          sumAdditionalDiscount,
          discountValue,
          sumIndividualDiscount,
          sumAfterDiscount,
          isTopDiscount,
          discountSum,
          nameEng,
          nameUkr,
          isService,
          isTotal,
          isAdvance,
          topDiscount,
        },
        index,
      ) => ({
        number: index + 1,
        id: index + (name ?? nameEng),
        title: isService || isTopDiscount || isTotal || isAdvance ? (language === "en" ? nameEng : nameUkr) : name,
        sum: numberFormat(sumBeforeDiscount),
        discountSum: isTopDiscount ? numberFormat(+discountSum + +topDiscount) : numberFormat(sumAdditionalDiscount),
        discountValue: numberFormat(discountValue),
        topDiscountSum: numberFormat(sumIndividualDiscount),
        resultSum: numberFormat(sumAfterDiscount),
      }),
    ) ?? []),
  ];

  return (
    <ReactTable
      columns={mainServicesAndDiscountsTableColumns}
      defaultData={mainServicesAndDiscountsTableData}
      className="fGrow scrollX scrollY fShrink mb0_5"
      tableClassName="fGrow"
      style={{height: "12em"}}
      selectable={false}
    />
  );
};

export default MainServicesAndDiscountsTable;
